import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'
import { styled } from '@linaria/react'
import { css } from '@linaria/core'

import pwa_icon from '../../assets/common/pwa_icon.webp'
import pwa_step_1 from '../../assets/common/pwa_step_1.webp'
import useTranslateImage from '../../hooks/useTranslateImage'
import closeModal from '../../utils/closeModal'
import Icon from '../icon'
import Modal from './modal'

const container = css`
  padding: 30px 14px 30px;
`

const Title = styled.h3`
  font-weight: 900;
  font-size: 20px;
  color: var(--txt);
  margin-bottom: 24px;
  text-align: center;
`

const Text = styled.p`
  font-size: 15px;
  color: var(--txt);
`

const CloseModal = styled.button`
  display: flex;
  position: absolute;
  top: 20px;
  right: 15px;
`

const PwaDownloadStepsModal = () => {
  const modal = useModal()
  const { t } = useTranslation('downloadPwa')
  const translateImage = useTranslateImage()

  return (
    <Modal id="pwa-download-steps-modal" containerStyle={container}>
      <CloseModal onClick={() => closeModal(modal)}>
        <Icon id="close" width="15" height="15" fill="#3F394C" />
      </CloseModal>
      <Title>{t('quick-access')}</Title>
      <div className="flx-ctr" style={{ marginBottom: 16 }}>
        <img
          src={pwa_icon}
          style={{ minWidth: 50, width: 50, marginRight: 12 }}
        />
        <Text>{t('add-icon')}</Text>
      </div>
      <Text style={{ marginBottom: 12 }}>{t('step-1')}</Text>
      <img src={pwa_step_1} style={{ width: '100%', marginBottom: 16 }} />
      <Text style={{ marginBottom: 12 }}>{t('step-2')}</Text>
      <img
        src={translateImage('pwa-step-2')}
        style={{ width: '100%', marginBottom: 16 }}
      />
    </Modal>
  )
}

export default NiceModal.create(PwaDownloadStepsModal)
